import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingTasksPanel = ({ prescriptions, labOrders, messages, onViewPrescriptions, onViewLabOrders, onViewMessages }) => {
  const taskSections = [
    {
      title: 'Pending E-Prescriptions',
      count: prescriptions?.length,
      icon: 'Pill',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      items: prescriptions?.slice(0, 3),
      onViewAll: onViewPrescriptions,
      renderItem: (item) => (
        <div key={item?.id} className="flex items-center justify-between p-3 bg-background rounded-md border border-border">
          <div className="flex-1">
            <p className="font-medium text-foreground text-sm">{item?.patientName}</p>
            <p className="text-xs text-muted-foreground">{item?.medication} - {item?.dosage}</p>
          </div>
          <div className="flex items-center space-x-2">
            <span className={`px-2 py-1 text-xs rounded-full ${
              item?.urgency === 'high' ? 'bg-error/10 text-error' :
              item?.urgency === 'medium'? 'bg-warning/10 text-warning' : 'bg-success/10 text-success'
            }`}>
              {item?.urgency}
            </span>
            <Button variant="ghost" size="xs" iconName="ChevronRight" />
          </div>
        </div>
      )
    },
    {
      title: 'Lab Orders',
      count: labOrders?.length,
      icon: 'TestTube',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      items: labOrders?.slice(0, 3),
      onViewAll: onViewLabOrders,
      renderItem: (item) => (
        <div key={item?.id} className="flex items-center justify-between p-3 bg-background rounded-md border border-border">
          <div className="flex-1">
            <p className="font-medium text-foreground text-sm">{item?.patientName}</p>
            <p className="text-xs text-muted-foreground">{item?.testType} - {item?.status}</p>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xs text-muted-foreground">{item?.orderedDate}</span>
            <Button variant="ghost" size="xs" iconName="ChevronRight" />
          </div>
        </div>
      )
    },
    {
      title: 'Patient Messages',
      count: messages?.length,
      icon: 'MessageSquare',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      items: messages?.slice(0, 3),
      onViewAll: onViewMessages,
      renderItem: (item) => (
        <div key={item?.id} className="flex items-center justify-between p-3 bg-background rounded-md border border-border">
          <div className="flex-1">
            <p className="font-medium text-foreground text-sm">{item?.patientName}</p>
            <p className="text-xs text-muted-foreground line-clamp-2">{item?.message}</p>
          </div>
          <div className="flex items-center space-x-2">
            {item?.unread && (
              <div className="w-2 h-2 bg-primary rounded-full" />
            )}
            <span className="text-xs text-muted-foreground">{item?.time}</span>
            <Button variant="ghost" size="xs" iconName="ChevronRight" />
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      {taskSections?.map((section) => (
        <div key={section?.title} className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className={`w-10 h-10 rounded-lg ${section?.bgColor} flex items-center justify-center`}>
                <Icon name={section?.icon} size={20} className={section?.color} />
              </div>
              <div>
                <h3 className="font-medium text-foreground">{section?.title}</h3>
                <p className="text-sm text-muted-foreground">{section?.count} pending</p>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="ExternalLink"
              iconPosition="right"
              onClick={section?.onViewAll}
            >
              View All
            </Button>
          </div>

          <div className="space-y-2">
            {section?.items?.length > 0 ? (
              section?.items?.map(section?.renderItem)
            ) : (
              <div className="text-center py-8">
                <Icon name={section?.icon} size={32} className="text-muted-foreground mx-auto mb-2" />
                <p className="text-sm text-muted-foreground">No pending {section?.title?.toLowerCase()}</p>
              </div>
            )}
          </div>

          {section?.items?.length > 3 && (
            <div className="mt-4 pt-4 border-t border-border">
              <Button
                variant="ghost"
                size="sm"
                fullWidth
                iconName="Plus"
                iconPosition="left"
                onClick={section?.onViewAll}
              >
                View {section?.count - 3} more
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PendingTasksPanel;